import { Link } from 'react-router-dom';
import { Card } from '../components/ui';

export default function NotFoundPage({ forbidden }: { forbidden?: boolean }) {
  return (
    <Card className="mx-auto mt-8 max-w-md text-center">
      <h1 className="text-xl font-bold">{forbidden ? 'ไม่มีสิทธิ์เข้าหน้านี้' : 'ไม่พบหน้าที่ต้องการ'}</h1>
      <Link to="/" className="mt-3 inline-block text-brand underline">
        กลับหน้าแรก
      </Link>
    </Card>
  );
}
